<style lang="scss" scoped="scoped">
	@keyframes twinkle {
		0% {
			opacity: 0.9;
		}

		100% {
			opacity: 0;
		}
	}

	.twinkle {
		animation: twinkle 0.8s infinite alternate;
	}
</style>

<template>
	<div ref="container"
		style="overflow: auto;height: 100%;position: relative;padding: 20px;display: flex;flex-direction: column;">
		<div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">{{ $t('zongtizhibiao') }}</p>
		</div>
		<div style="display: flex;flex-direction: column;flex: 1;">
			<div style="display: flex;align-items: center;">
				<p style="font-size: 36px;font-weight: bold;"
					:style="{ color: statusColors[tabsData.eqPoints['CurrentState']] }">{{ equipment.name }}</p>
				<div class="twinkle"
					style="width: 14px;height: 14px;margin-left: 24px;display: flex;justify-content: center;align-items: center;border-radius: 50%;"
					:style="{ background: statusColors2[tabsData.eqPoints['CurrentState']] }">
					<div style="width: 6px;height: 6px;border-radius: 50%"
						:style="{ background: statusColors[tabsData.eqPoints['CurrentState']] }"></div>
				</div>
				<p style="font-size: 14px;margin-left: 10px;"
					:style="{ color: statusColors[tabsData.eqPoints['CurrentState']] }">
					{{ $t(status[tabsData.eqPoints['CurrentState']]) }}</p>
			</div>
			<div v-show="gridFlowHeight>0" :style="{ width: titleBarWidth + 'px' }"
				style="overflow: hidden;padding-top: 46px;padding-bottom: 20px;">
				<auto_scroll>
					<div ref="flow" id="web_monitor_workshop_mes_about_flow"
						:style="{ height: gridFlowHeight == 0 ? 100 : gridFlowHeight + 'px', width: gridFlowWidth == 0 ? 100 : gridFlowWidth + 'px' }"
						style="flex-shrink: 0;"></div>
				</auto_scroll>
			</div>
			<div style="flex: 1;display: flex;flex-direction: column;justify-content: space-between;padding:20px 0;">
				<div style="display: flex;">
					<div style="width: 50%;">
						<p style="font-size: 16px;color: #C0C4CC;line-height:26px">{{ $t('chanpinbianma') }}</p>
						<p style="font-size: 20px;color: #ffffff;">
							{{ tabsData.eqPoints['MaterialCode'] ? tabsData.eqPoints['MaterialCode'] : '-' }}</p>
					</div>
					<div style="width: 50%;">
						<p style="font-size: 16px;color: #C0C4CC;line-height:26px">{{ $t('chanpinmingcheng') }}</p>
						<p style="font-size: 20px;color: #ffffff;">
							{{ tabsData.eqPoints['MaterialName'] ? tabsData.eqPoints['MaterialName'] : '-' }}</p>
					</div>
				</div>
				<div style="display: flex;margin-top:4px;">
					<div style="width: 50%;">
						<p style="font-size: 16px;color: #C0C4CC;line-height:26px">{{ $t('kaijilv') }}</p>
						<p style="font-size: 20px;color: #ffffff;">
							{{ (tabsData.eqPoints['UpTimeRate'] * 1).toFixed(1) }}%</p>
					</div>
					<div style="width: 50%;">
						<p style="font-size: 16px;color: #C0C4CC;line-height:26px">{{ $t('jiadonglv') }}</p>
						<p style="font-size: 20px;color: #ffffff;">
							{{ (tabsData.eqPoints['TimeEfficency'] * 1).toFixed(1) }}%</p>
					</div>
				</div>
				<div style="display: flex;margin-top:4px;">
					<div style="width: 50%;">
						<p style="font-size: 16px;color: #C0C4CC;line-height:26px">{{ $t('yibaogongliangpinshu') }}</p>
						<p style="font-size: 20px;color: #ffffff;">
							{{ tabsData.eqPoints['GoodQuantity'] ? (tabsData.eqPoints['GoodQuantity'] * 1).toFixed(0) : '-' }}
						</p>
					</div>
					<div style="width: 50%;">
						<p style="font-size: 16px;color: #C0C4CC;line-height:26px">{{ $t('jihuashuliang') }}</p>
						<p style="font-size: 20px;color: #ffffff;">
							{{ tabsData.eqPoints['PlanQuantity'] ? (tabsData.eqPoints['PlanQuantity'] * 1).toFixed(0) : '-' }}
						</p>
					</div>
				</div>
				<div style="display: flex;margin-top:4px;">
					<div style="width: 50%;">
						<p style="font-size: 16px;color: #C0C4CC;line-height:26px">{{ $t('yibaogongbuliangpinshu') }}
						</p>
						<p style="font-size: 20px;color: #ffffff;">
							{{ tabsData.eqPoints['BadQuantity'] ? (tabsData.eqPoints['BadQuantity'] * 1).toFixed(0) : '-' }}
						</p>
					</div>
					<div style="width: 50%;">
						<p style="font-size: 16px;color: #C0C4CC;line-height:26px">{{ $t('shengchanjindu') }}</p>
						<p style="font-size: 20px;color: #ffffff;">
							{{ tabsData.eqPoints['Progress'] ? (tabsData.eqPoints['Progress'] * 100).toFixed(1) + '%' : '-' }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_workshop_mes_equipment_about',
		components: {},
		props: {
			equipment: {
				type: Object,
				default: function() {
					return {};
				}
			},
			tabsData: {
				type: Object,
				default: function() {
					return {};
				}
			}
		},
		watch: {
		      tabsData: {
		        handler(newValue, oldValue) {
					this.initPie()
		        },
		        deep: true,
		        // immediate: true
		      }
		    },
	
		data() {
			return {
				
				gridFlowHeight: 83,
				gridFlowWidth: 0,
				titleBarWidth: 0,
				status: {
					'0': 'shengchanzhong',
					'1': 'kongxian',
					'3': 'guzhang',
					'-1': 'lixian'
				},
				statusColors: {
					'0': 'rgba(125, 255, 190, 1)',
					'1': 'rgba(255, 213, 128, 1)',
					'3': 'rgba(255, 128, 159, 1)',
					'-1': 'rgba(117, 130, 163, 1)'
				},
				statusColors2: {
					'0': 'rgba(125, 255, 190, 0.5)',
					'1': 'rgba(255, 213, 128, 0.5)',
					'3': 'rgba(255, 128, 159, 0.5)',
					'-1': 'rgba(117, 130, 163, 0.5)'
				}
			};
		},
		created() {},
		mounted() {
			this.resize();
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
			//时间比最后的resize晚，这样就不会被打断导致动画不流畅
			setTimeout(() => {
				this.initPie();
			}, 500);
		},
		destroyed() {},
		methods: {
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					if (!this.$refs.titleBar) {
						return;
					}
					// this.gridFlowHeight = this.$refs.flow.offsetHeight
					this.titleBarWidth = this.$refs.titleBar.offsetWidth
					this.countFlowHeihgt();
					// if (this.chart) {
					// 	this.chart.resize()
					// }
				}, 500);
			},
			initPie() {
				document.getElementById("web_monitor_workshop_mes_about_flow").innerHTML = '';
				let woProcedureList = this.tabsData.eqPoints['woProcedureList'] || [];
				let nodes = woProcedureList.map(item => {
					return {
						id: item.routeWorkProcedureId + '',
						shape: 'node4',
						width: 83,
						height: 60,
						data: {
							id: 'web_monitor_workshop_mes_about_flow'+"_"+item.routeWorkProcedureId,
							color: this.statusColors[this.tabsData.eqPoints['CurrentState']],
							title: item.procedureDesc,
							percent: (item.finishGoodQuantity) / item.planQuantity
						}
					};
				});

				let edges = [];
				for (var j = 0; j < woProcedureList.length; j++) {
					let node = woProcedureList[j];
					if (woProcedureList[j].parentIds == '') {
						continue;
					}
					let parentIdArr = woProcedureList[j].parentIds.split(',');
					for (var k = 0; k < parentIdArr.length; k++) {
						edges.push({
							attrs: {
								line: {
									targetMarker: {
										tagName: 'circle',
										r: 2,
										cx: 2,
										fill: '#C0C4CC',
										stroke: '#C0C4CC'
									},
									stroke: '#C0C4CC',
									strokeWidth: 1
								}
							},
							source: parentIdArr[k],
							target: node.routeWorkProcedureId + '',
							router: {
								name: 'manhattan',
								startDirections: ['right'],
								endDirections: ['left']
							}
						});
					}

				
				}
				this.initFlow('web_monitor_workshop_mes_about_flow', nodes, edges);
				this.countFlowHeihgt();
			},

			initFlow(id, nodes, edges) {

				this.graph = new this.x6({
					container: document.getElementById(id),
					width: 'auto',
					height: 'auto',
					grid: false,
					interacting: {
						nodeMovable: false
					}
				});

				const model = {
					nodes: nodes,
					edges: edges
				};
				const dagreLayout = new this.x6layout({
					type: 'dagre',
					rankdir: 'LR',
					align: 'UL',
					// rankdir: 'TB',
					// align: 'DR',
					ranksep: 25,
					nodesep: 10,
					controlPoints: true
				});
				const newModel = dagreLayout.layout(model);
				let a = this.graph.fromJSON(newModel);
				console.log(a);
				a = null;

				// this.models[id] = dagreLayout.layout(model)
				// this.graph.fromJSON(this.models[id])
			},
			countFlowHeihgt() {
				setTimeout(() => {
					//貌似如果只有一个流程是不会有viewport，所以这里要看看是不是
					let id = 'web_monitor_workshop_mes_about_flow';
					console.log(document.getElementById(id))
					this.gridFlowHeight =
						document
						.getElementById(id)
						.getElementsByClassName('x6-graph-svg-viewport')[0]
						.getBoundingClientRect().height + 40;
					this.gridFlowWidth =
						document
						.getElementById(id)
						.getElementsByClassName('x6-graph-svg-viewport')[0]
						.getBoundingClientRect().width + 40;
				}, 1000);
			}
		}
	};
</script>
